import React, { useEffect, useState } from "react";
import Styles from "./styles.module.scss";
import i18n from "i18next";
import listArrowIcon from "../../theme/assets/svg/omt_list_arrow_icon.svg";

const LS_KEY = "launchpadLng";
const allLngs = ["ru", "en", "de", "es", "zh"];

const LangSwitcher = ({ isVertical, isOpen, onToggle, onClose }) => {
    // 1) Берем из LS, если нет — используем i18n.language (или 'en')
    const [currentLng, setCurrentLng] = useState(() => {
        const saved = localStorage.getItem(LS_KEY);
        const initial =
            saved && allLngs.includes(saved) ? saved : i18n.language || "en";
        return initial;
    });

    // 2) Если в LS пусто — записываем первый раз + синхронизируем i18n
    useEffect(() => {
        const saved = localStorage.getItem(LS_KEY);
        if (!saved) localStorage.setItem(LS_KEY, currentLng);

        // синк i18n (на случай если LS и i18n расходятся при старте)
        if (i18n.language !== currentLng) i18n.changeLanguage(currentLng);

        // font class
        const html = document.documentElement;
        if (currentLng === "ru") html.classList.add("withRuFont");
        else html.classList.remove("withRuFont");
    }, [currentLng]);

    const changeLanguage = (lng) => {
        if (!allLngs.includes(lng)) return;

        i18n.changeLanguage(lng);
        setCurrentLng(lng);
        localStorage.setItem(LS_KEY, lng);

        // ✅ после выбора языка — закрываем дропдаун
        if (onClose) onClose();
    };

    return (
        <section
            className={`${Styles.container} ${
                isVertical ? Styles.containerVertical : ""
            }`}
        >
            <div className={Styles.contentWrap}>
                <div className={Styles.currentLangBox} onClick={onToggle}>
                    <div className={Styles.currentLang}>{currentLng}</div>
                    <div className={`${Styles.imgWrap} ${isOpen ? Styles.imgWrapActive : ""}`}>
                        <img src={listArrowIcon} alt="drop arrow" />
                    </div>
                </div>

                <div className={`${Styles.allLangWrap} ${isOpen ? Styles.allLangWrapActive : ""}`}>
                    <div className={Styles.allLangBox}>
                        {allLngs.map((item, index) => (
                            <div
                                key={"allLngs" + index}
                                className={`${Styles.allLangBoxItem} ${
                                    currentLng === item ? Styles.allLangBoxItemActive : ""
                                }`}
                                onClick={() => changeLanguage(item)}
                            >
                                {item}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default LangSwitcher;
